import script from "./AssetInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetInformation.vue?vue&type=script&setup=true&lang=js"

import "./AssetInformation.vue?vue&type=style&index=0&id=6673202d&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6673202d"]])

export default __exports__